// dynamic-routes-menu.ts
import { request } from "../services";

let inflight: Promise<string[]> | null = null;
let cache: string[] | null = null;
let cacheAt = 0;
const TTL = 30_000; // 30s

function mapRoutes(raw: any): string[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((x: any) => (typeof x === "string" ? x : x?.route))
    .filter((v: any): v is string => typeof v === "string")
    .sort((a, b) => a.localeCompare(b));
}

export function arraysSame(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;         // важливо
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}

export function getLsRoutes(): string[] {
  try {
    const raw = localStorage.getItem("dynamicRoutes");
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch { return []; }
}

export function setLsRoutes(routes: string[]) {
  localStorage.setItem("dynamicRoutes", JSON.stringify([...routes].sort((a,b)=>a.localeCompare(b))));
}

export async function getDynamicRoutes(): Promise<string[]> {
  // кеш
  if (cache && Date.now() - cacheAt < TTL) return cache;
  // дедуп запиту
  if (inflight) return inflight;

  inflight = request("/profile/menu-tabs/getdatatable", {
    method: "get",
    cancelTokenKey: "getDynamicRoutes",
  })
    .then((resp) => {
      const list = mapRoutes(resp?.content ?? []);
      cache = list;
      cacheAt = Date.now();
      return list;
    })
    .finally(() => { inflight = null; });

  return inflight;
}

export async function wrapperDynamicRoutes(pathname: string): Promise<boolean> {
  const ls = getLsRoutes();
  try {
    const fromApi = await getDynamicRoutes();
    if (!arraysSame(fromApi, ls)) setLsRoutes(fromApi);

    // просте та надійне порівняння
    return fromApi.some(u => u === pathname);
  } catch (e) {
    console.error("Failed to load dynamic routes", e);
    return ls.includes(pathname);
  }
}
